import React from 'react'

import { useFlag } from '@sketch/modules-common'

import { DetailViewQuery } from '../DetailView/DetailViewQueries'
import { ArtboardDetailQueries, ArtboardDetailQueriesProps } from './components'

export function ArtboardDetailViewFFGate(props: ArtboardDetailQueriesProps) {
  const isMarinaInspectorOn = useFlag('web-renderer-marina-inspector')

  if (isMarinaInspectorOn) {
    // Newest version using the PRFile as source for the inspector but still partially relying on some old inspector data for now
    // This is WIP and not stable yet.
    return <ArtboardDetailQueries {...props} />
  } else {
    // Note: Ignoring the value of web-renderer-handoff FF and always showing
    // the web renderer detail view for now. This is so anon users can see the
    // web renderer too, but we can still rollback if needed. When this view is
    // stable, we can go ahead and delete the old detail view code.
    return <DetailViewQuery {...props} />
  }
}
